import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { RotinaService } from '../rotina.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { ProcessoService } from '../../processo/processo.service';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-selecao-rotinas-cliente',
  templateUrl: './selecao-rotinas-cliente.component.html',
  styleUrls: ['./selecao-rotinas-cliente.component.css']
})
export class SelecaoRotinasClienteComponent implements OnInit {

  @Output() rotinaProcessoEvent: EventEmitter<RotinaProcesso[]>;
  @Input() processosCliente: ProcessoCliente[];

  filtroPesquisaNomeRotina: string;

  rotinasCliente: RotinaCliente[];
  rotinasProcesso: RotinaProcesso[];

  paginacao: Paginacao;

  evento: Evento;

  selecionados: boolean;

  public loading = false;

  constructor(private _rotinaService: RotinaService,
    private _comumService: ComumService,
    private _processoService: ProcessoService,
    private _cookieService: CookieService,
    public _authService: AuthService) {
    this.paginacao = new Paginacao();

    this.evento = this._comumService.evento;

    this.rotinaProcessoEvent = new EventEmitter<RotinaProcesso[]>();
    this.rotinasCliente = new Array<RotinaCliente>();
    this.rotinasProcesso = new Array<RotinaProcesso>();

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 2000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    const self = this;

    this._rotinaService.obterRotinasClienteHttp(parseInt(this._cookieService.get('idCliente'), 10))
      .subscribe((rotinasCliente) => {
        self._rotinaService.obterRotinasProcessosFromProcessosClienteHttp(this.processosCliente)
          .subscribe((rotinasProcesso: RotinaProcesso[]) => {
            self.rotinasProcesso = rotinasProcesso;
            for (const rotinaCliente of rotinasCliente) {
              for (const rotinaProcesso of rotinasProcesso) {
                if (rotinaCliente.idRotinaCliente === rotinaProcesso.rotinaCliente.idRotinaCliente) {
                  rotinaCliente.selecionado = true;
                  break;
                }
              }
              self.rotinasCliente.push(rotinaCliente);
              self.loading = false;
            }
          });
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeRotina = filtro.value;
  }

  selecionar(rotinaCliente: RotinaCliente): void {
    rotinaCliente.selecionado = !rotinaCliente.selecionado;
    rotinaCliente.alterado = true;
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    this.rotinasCliente.forEach(rotinaCliente => {
      rotinaCliente.selecionado = this.selecionados;
      rotinaCliente.alterado = true;
    });
  }

  emit(): void {
    const rotinasSelecionadas: RotinaProcesso[] = new Array<RotinaProcesso>();
    const processosSetorSelecionados: ProcessoSetor[] = new Array<ProcessoSetor>();

    this._processoService.obterProcessosSetorClienteHttp(parseInt(this._cookieService.get('idCliente'), 10))
      .subscribe(processosSetor => {
        for (const processoSetorSelecionado of processosSetor) {
          for (const processoCliente of this.processosCliente) {
            if (processoSetorSelecionado.idProcessoCliente === processoCliente.idProcessoCliente) {
              processosSetorSelecionados.push(processoSetorSelecionado);
            }
          }
        }

        for (const rotinaCliente of this.rotinasCliente) {
          if (rotinaCliente.selecionado) {
            for (const processoSetor of processosSetorSelecionados) {
              const novaRotinaProcesso = new RotinaProcesso();
              novaRotinaProcesso.rotinaCliente.idRotinaCliente = rotinaCliente.idRotinaCliente;
              novaRotinaProcesso.processoSetor.idProcessoSetor = processoSetor.idProcessoSetor;
              novaRotinaProcesso.selecionado = true;
              novaRotinaProcesso.alterado = true;
              for (const rotinaProcesso of this.rotinasProcesso) {
                if (rotinaProcesso.rotinaCliente.idRotinaCliente === rotinaCliente.idRotinaCliente
                  && rotinaProcesso.processoSetor.idProcessoSetor === processoSetor.idProcessoSetor) {
                  novaRotinaProcesso.alterado = false;
                  break;
                }
              }
              if (novaRotinaProcesso.alterado) {
                rotinasSelecionadas.push(novaRotinaProcesso);
              }
            }
          } else if (!rotinaCliente.selecionado && rotinaCliente.alterado) {
            for (const rotinaProcesso of this.rotinasProcesso) {
              if (rotinaProcesso.rotinaCliente.idRotinaCliente === rotinaCliente.idRotinaCliente) {
                rotinaProcesso.selecionado = false;
                rotinaProcesso.alterado = true;
                rotinasSelecionadas.push(rotinaProcesso);
              }
            }
          }
        }
        this.rotinaProcessoEvent.emit(rotinasSelecionadas);
      });
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/selecao-rotinas-cliente/selecao-rotinas-cliente.component.ts